import parentPath from "../path";

const subscriptionsPath = `${parentPath}/subscriptions`;

export default subscriptionsPath;
